<div class="row reportHeaderTopSec">
  <div class="col-md-8">
    <p>
      <label>Account:</label>
      <span>{{accountNumber}} - {{selectedAccount}}</span>
    </p>
    <p>
      <label>Company:</label>
      <span>{{headerCompany}} - {{companyName}}</span>
    </p>
  </div>
  <div class="col-md-4 text-right">
    <button mat-raised-button class="btns" color="primary" [disabled]="productAvailabilityList.length <= 0" (click)="export()">Export</button>
  </div>
  <div class="col-md-12 col-lg-12 orderQuantity">
    <span class="padding-t20">Display product with Availability > 0</span>
    <mat-checkbox class="custom-checkbox margin-l10"
                  #getZeroQtyRecords
                  [checked]="ignoreZeroQtyRecords"
                  (change)="filterNonZeroAvailabilityDetail(getZeroQtyRecords._checked)"
                  title="Display product with Availability > 0"></mat-checkbox>
  </div>
</div>
<div class="row">
  <div class="col-md-12 margin-t10">
    <!--<div class="fulfill-top-sec">
      <div class="row listing-action-items">
        <div class="col-xl-12 col-lg-12 col-md-12 text-right">
          <mat-paginator #productPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
        </div>
      </div>
    </div>-->
    <div class="tableContainer margin-t0 productAvailTable">
      <table mat-table #availabilityTable [dataSource]="productAvailabilityListDS" matSort matSortDirection="desc" class="matTables productTable">

        <ng-container matColumnDef="itemDescription">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="productNameBlock">Product Name </th>
          <td mat-cell *matCellDef="let element" class="order-info">
            <p title="{{element.brand}} - {{element.marketingBrand}}"> {{element.brand}} - {{element.marketingBrand}}</p>
            <p class="grower-name">
              <a title="{{element.itemDescription}}">
                {{element.itemDescription}}
              </a>
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="seedAvailability">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center margin-t0 availabilityCol"> Availability </th>
          <td mat-cell *matCellDef="let element" class="text-center"> {{element.seedAvailability}} </td>
        </ng-container>
        <ng-container matColumnDef="maturity">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center maturityCol"> Maturity </th>
          <td mat-cell *matCellDef="let element" class="text-center"> {{element.maturity}} </td>
        </ng-container>

        <ng-container matColumnDef="seedSize">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center seedSizeCol"> Seed Size </th>
          <td mat-cell *matCellDef="let element" class="text-center"> {{element.seedSize}} </td>
        </ng-container>

        <ng-container matColumnDef="packageSize">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center packageCol"> Package Size </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <span class="oval-shape" [ngClass]="{'pack-size': (element.highlightPackage===1)}" title="{{element.packageSize}}">
              {{element.packageSize}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="treatment">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center treatmentCol"> Treatment </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <span class="oval-shape" [ngClass]="{'treatment': (element.highlightTreatment===1)}" title="{{element.treatment}}">
              {{element.treatment}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="technology">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center technologyCol"> Technology </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" title="{{element.technology}}">
              {{element.technology}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="marketingBrand">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center marketingCol"> Marketing Brand </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <span class="oval-shape" [ngClass]="{'treatment': (element.marketingBrand===1)}" title="{{element.marketingBrand}}">
              {{element.marketingBrand}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="productLine">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center prodLineCol"> Product Line </th>
          <td mat-cell *matCellDef="let element" class="product-line text-center">
            <span>
              {{element.productLine}}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedResultColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedResultColumns;"></tr>
      </table>
    </div>
  </div>
</div>
<div class="row tableTotalsSec">
  <div class="col-md-6 searchedDateTime padding-l0">
    <p>
      <label>Date And time</label>
      <span>{{curentDateTime | date: 'MM-dd-yyyy' }}</span>
    </p>
  </div>
  <div class="col-md-6 text-right">
    Products Searched:
    <span class="count"> {{productAvailabilityList.length}} </span>

    <!--<a style="cursor:pointer" (click)="onCancel()">Cancel </a>-->
  </div>
</div>
